export enum ApiKeysServiceActions {
  ALL = '*',
  ApiKeys = '',
}
